import { Button, styled } from '@mui/material'

export const Container = styled('div')`
  height: ${({ theme }) => theme.spacing(5.5)};
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const InputButton = styled(Button)`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  height: ${({ theme }) => theme.spacing(5.5)};
  width: ${({ theme }) => theme.spacing(5.5)};

  :focus {
    background-color: transparent !important;
    // media query to check if the user uses a touch device to avoid passing isNative
    @media (pointer: coarse) {
      background-color: transparent !important;
    }
  }

  :hover {
    background-color: ${({ theme }) => theme.palette.secondary.hover};
    // media query to check if the user uses a touch device to avoid passing isNative
    @media (pointer: coarse) {
      background-color: transparent !important;
    }
  }
`
